export const art = {
  pixelThings: [
    {
      src: '/images/hot chocolate.gif',
      width: 1,
      height: 1
    },
    {
      src: '/images/sepiroth.gif',
      width: 1,
      height: 1
    },
    {
      src: '/images/roman.png',
      width: 3,
      height: 3
    },

    {
      src: '/images/courageous_thief_elf_anim.gif',
      width: 1,
      height: 1
    },
    {
      src: '/images/nes_with_feedback_outline.gif',
      width: 4,
      height: 3
    },
    {
      src: '/images/smith.gif',
      width: 4,
      height: 4
    },

    {
      src: '/images/Akiraposter.png',
      width: 3,
      height: 4
    },

    {
      src: '/images/doge_colour_gif.gif',
      width: 1,
      height: 1
    },
    {
      src: '/images/sleeping_kitty.gif',
      width: 4,
      height: 3
    },

    {
      src: '/images/scarf.png',
      width: 4,
      height: 3
    }
  ],
  isometricThings: [
    {
      src: '/images/lighthouse.png',
      width: 4,
      height: 3
    },
    {
      src: '/images/temple.png',
      width: 4,
      height: 3
    }
  ],
  digitalArtThings: [
    {
      src: '/images/amanda_fin.jpg',
      width: 1,
      height: 1
    },
    {
      src: '/images/ladymaria.jpg',
      width: 1.5,
      height: 2
    },
    {
      src: '/images/withwater.png',
      width: 0.8,
      height: 1
    },
    {
      src: '/images/hollowknight.jpg',
      width: 1.7,
      height: 2
    },
    {
      src: '/images/20210208082031.png',
      width: 5,
      height: 4
    },
    {
      src: '/images/aliceinwaterland.jpg',
      width: 1.5,
      height: 2
    },
    {
      src: '/images/tsushima.jpg',
      width: 1.4,
      height: 2
    },
    {
      src: '/images/afterschoolactivities.jpg',
      width: 1.4,
      height: 2
    },

    {
      src: '/images/PXL_20201208_160705833.jpg',
      width: 1.3,
      height: 2
    },
    {
      src: '/images/annabeancolourcrop.png',
      width: 1.5,
      height: 2
    }
  ]
}
